import { Home, Layers, PackageOpen, Settings } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { TranslationKeys } from '@/shared/i18n/locales/en'

export const SIDEBAR_WIDTH = 240
export const SIDEBAR_COLLAPSED_WIDTH = 64

export interface NavItem {
    /** i18n key — must be a key of TranslationKeys */
    labelKey: keyof TranslationKeys
    path: string
    icon: LucideIcon
    /** If set, the item only shows for users holding this realm role. */
    requiresRole?: string
}

/**
 * Navigation items — extend this array in downstream applications.
 * Each entry appears in both the desktop sidebar and mobile bottom nav.
 * Items with `requiresRole` are hidden from users lacking that role.
 */
export const NAV_ITEMS: NavItem[] = [
    { labelKey: 'navHome',      path: '/',         icon: Home },
    { labelKey: 'navFoams',     path: '/foams',    icon: Layers, requiresRole: 'admin' },
    { labelKey: 'navTrolleys',  path: '/trolleys', icon: PackageOpen },
    { labelKey: 'navSettings',  path: '/settings', icon: Settings },
]
